import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { userProfileApi } from 'src/api/administration/user-profile-api';
import { useAppSelector } from 'src/app/hooks';
import { fetchToken } from 'src/firebase';

export interface UserState {
  username: string;
  fullName: string;
  deptName?: string | undefined;
  avatar?: string | undefined;
  roleId?: string | undefined;
  gender?: string | undefined;
  birthDay?: Date | undefined;
  roleName?: string | undefined;
  deptId: string;
  myDeptIds: string[];
  userType: string;
  deptsAdmin: string[];
  roleDetail: any;
  isFirstLogin: boolean;
}

const initialState: UserState = {
  username: '',
  fullName: '',
  deptName: '',
  avatar: '',
  roleId: '',
  deptId: '',
  myDeptIds: [],
  userType: '',
  deptsAdmin: [],
  roleDetail: [],
  isFirstLogin: false,
};

export const getUserInfo = createAsyncThunk(
  'auth/info',
  async (arg, { getState }) => {
    const state = getState() as RootState;
    if (!state.userInfo.roleId) {
      try {
        const userProfile = await userProfileApi.getCurrentUser();
        // await fetchToken((obj: any) => {});
        return userProfile;
      } catch (error: any) {

        // fake data để tạm thời get được data unit
        const fakeUserProfile = {
          id: 'fake-user-id-001',
          username: 'admin.demo',
          fullName: 'Nguyễn Văn Admin',
          gender: '1',
          birthDay: '1990-01-01',
          email: 'admin.demo@bca.vn',
          phone: '0123456789',
          avatar: '',
          deptName: 'Phòng Công nghệ thông tin',
          roleId: 'role-admin',
          roleName: 'Quản trị viên',
          deptId: 'dept-001',
          myDeptIds: ['dept-001', 'dept-002'],
          userType: 'role-admin',
          deptIds: ['dept-001', 'dept-002'],
          roleDetail: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_DEPARTMENT_MANAGER'],
          createdDate: new Date().toISOString(),
          createdBy: 'system',
          lastModifiedDate: new Date().toISOString(),
          lastModifiedBy: 'system',
          isDeleted: 'false',
        };
        await fetchToken((obj: any) => {});
        return fakeUserProfile;
      }
    }
  },
);

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      getUserInfo.fulfilled,
      (state, action: any) => {
        if (action.payload) {
          state.username = action.payload.username;
          state.fullName = action.payload.fullName;
          state.deptName = action.payload.deptName;
          state.avatar = action.payload.avatar;
          state.roleId = action.payload.roleId;
          state.gender = action.payload.gender;
          state.birthDay = action.payload.birthDay;
          state.roleName = action.payload.roleName;
          state.deptId = action.payload.deptId;
          state.myDeptIds = action.payload.myDeptIds;
          state.userType = action.payload.userType;
          state.deptsAdmin = action.payload.deptIds;
          state.roleDetail = action.payload.roleDetail;
          state.isFirstLogin = !!action.payload.isFirstLogin;
        }
      },
    );
  },
});

export const {} = userInfoSlice.actions;

export const selectUserInfo = (state: RootState) =>
  state.userInfo;

export default userInfoSlice.reducer;
